var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbhead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3090_514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 3.58174 12.4183 1.04904e-05 7.99999 1.04904e-05C3.58173 1.04904e-05 0 3.58174 0 8C0 11.7518 2.58288 14.8999 6.06739 15.7644V10.4447H4.41772V8H6.06739V6.9466C6.06739 4.22365 7.29964 2.96158 9.97292 2.96158C10.4797 2.96158 11.3543 3.06094 11.712 3.16033V5.37645C11.5232 5.35658 11.1953 5.34663 10.7878 5.34663C9.47603 5.34663 8.96918 5.84353 8.96918 7.13543V8H11.5823L11.1334 10.4447H8.96918V15.9414C12.9303 15.463 16 12.0902 16 8Z",
    fill: "#0866FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1331 10.4447L11.5821 8.00001H8.96897V7.1354C8.96897 5.8435 9.47578 5.34663 10.7876 5.34663C11.195 5.34663 11.5229 5.35655 11.7118 5.37642V3.16033C11.354 3.06094 10.4795 2.96154 9.97268 2.96154C7.29943 2.96154 6.06714 4.22366 6.06714 6.9466V8.00001H4.41748V10.4447H6.06714V15.7644C6.68612 15.918 7.33332 16 7.99975 16C8.32788 16 8.65121 15.9798 8.96897 15.9414V10.4447H11.1331Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3090_514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbhead);
export default __webpack_public_path__ + "static/media/fbhead.1cae3b688e2316d7afdcfa2d3afe866f.svg";
export { ForwardRef as ReactComponent };